import React from "react";

import "./policy.css";

const Poilcy = () => {
  return (
    <div className="main-policy">
      <div className="header-policy">
        <p>PRIVACY POLICY</p>
      </div>
      <div className="content-policy">
        <p>
          BBL’s Privacy Policy applies solely to information collected by us and
          may differ from the policies of other companies’ or organisations’
          websites that you link to from this website. Please read the privacy
          policy of any other companies’ or organisations’ website that you link
          to from our website.
        </p>
      </div>
      <div className="policies">
        <div className="p1">
          <h3>LIABILITY</h3>
          <p>
            BBL makes no warranties or representations about this Website or any
            of its content. BBL is not responsible to you or anyone else for any
            damages of any kind, including (but not limited to) any direct or
            consequential loss and losses resulting from security failure,
            disclosure of confidential information by other parties or the
            transmission of a computer virus, suffered in connection with the
            use of this Website whether based on breach of contract or warranty,
            tort (including negligence), product liability or otherwise ,even if
            BBL is informed in advance of the possibility of such damages. BBL
            excludes, to the extent permitted by law, any liability which may
            arise as a result of the use of this Website. By using the Website,
            you agree to indemnify BBL for any loss or liability arising out of
            your use. Use of the Website is at your own risk and you assume full
            responsibility and risk of loss resulting from your downloading, use
            of, or access to data, files, information, or other material on or
            through the Website.
          </p>
          <h3>GOVERNING LAW</h3>
          <p>
            The Terms of Use will be governed by and interpreted in accordance
            with the laws of Nigeria and you submit to the non-exclusive
            jurisdiction of the courts of Nigeria.
          </p>
          <h3>USER-GENERATED CONTENT TERMS OF USE</h3>
          <p>
            Please read these Terms of Use carefully, as they apply to your
            submitting content to Blaze Brand Limited (“BBL”) social networks,
            websites and other forms of media (“User-generated Websites”). BBL
            owns and/or operates various User-generated Websites that permit
            users to submit, post, publish, tag or upload (“Submit”) content,
            which may include, but is not limited to, comments, graphics,
            information, photos, reviews, text, videos or any combination
            thereof (collectively, “Content”). When you Submit Content to a
            User-generated Website, you accept and agree to be bound by these
            Terms of Use, which form a legally binding agreement between you and
            BBL. If you do not want to be bound by these Terms of Use, do not
            Submit Content. In particular, but without limitation, you confirm
            the following: You are granting BBL and its affiliates the right to
            use your Content on their social networks, websites and other forms
            of media described below, indefinitely; You created the Content or
            have permission from the creator of the Content to grant the right
            to use the Content; You have all necessary rights and permissions to
            grant the right to use the Content with respect to all individuals
            appearing in the Content; You are at least 18 years of age. Further,
            we may amend these Terms of Use at any time. Your continued use of
            the Website is considered to be acceptance of the amended Terms of
            Use.
          </p>
          <h3>CONTENT</h3>
          <p>
            When you Submit your Content, you authorise BBL and its affiliates a
            non-exclusive, fully paid-up, irrevocable, perpetual, royalty-free,
            worldwide license (including the right to sub-license through
            multiple tiers) to use, adapt, display, distribute, modify, process,
            prepare derivative works, publicly display, publicly perform,
            publish, reproduce and transmit your Content, in part or in full, in
            any form, medium or distribution method, for any purpose, including
            without limitation, any purpose relating to the advertising,
            marketing, and promotion of BBL'S and its affiliates’ goods and
            services. These uses may include, but are not limited to, posting
            your Content on social networks or websites, transmitting your
            Content via emails, displaying your Content on computers or mobile
            devices, or reproducing your Content in print. Any Content you
            Submit is, and will be treated as, non-confidential and
            non-proprietary. BBL may use any Content you Submit and reproduce it
            for any purpose. Specifically, BBL is free to use for any purposes
            whatsoever (including, but not limited to, the advertising,
            developing, manufacturing and marketing of products and services)
            any artwork, concepts, ideas or suggestions contained in any Content
            you Submit. Any such use is without compensation to you. By
            Submitting Content, you are also warranting that you own the Content
            Submitted and that BBL use will not violate any third party's rights
            or otherwise place us in breach of any applicable laws. BBL is under
            no obligation to use the information Submitted. You understand that
            BBL employs both internal and external resources which may have
            developed or may in the future develop ideas identical or similar to
            your Content and that BBL is only willing to consider the Content on
            these terms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Poilcy;
